import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {LoadingState} from './loading-state.model';
import * as LoadingStateActions from './loading-state.actions';

export const loadingStatesFeatureKey = 'loadingStates';

export interface State extends EntityState<LoadingState> {
  // additional entities state properties
}

export const adapter: EntityAdapter<LoadingState> = createEntityAdapter<LoadingState>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,
  on(LoadingStateActions.setLoadingState,
    (state, action) => adapter.upsertOne(action.loadingState, state)
  ),
  on(LoadingStateActions.deleteLoadingState,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(LoadingStateActions.clearLoadingStates,
    state => adapter.removeAll(state)
  ),
);


export const {
  selectAll,
} = adapter.getSelectors();
